module.exports = __webpack_public_path__ + "img/ydd_jbm.51197deb.png";